<!-- Prima del footer -->

<section  class="emp-section-wrapper emp-newsletter-wrapper">
    <app-newsletter-form></app-newsletter-form>
</section>
<footer class="">
    <div class="row emp-info-link-container emp-section-wrapper emp-section-wrapper-local">
        <div class="col-12 col-md-4 col-xl-3 company-info">

            <div class="col-12 footer-logo">
                <img [src]="company_logo_url + 'logo.webp'" alt="" loading="lazy" />
            </div>

            <h3 class="company-info__title">
                {{ "footer.contatti" | T }}
            </h3>
            
            <ul class="company-info__list">
                @for(item of company_data | keyvalue:null ; track item.key){
                    @if(isObject(item.value)){
                        @if(item.key == 'address'){
                            <li class="company-info__item">
                                <span class="company-info__value">{{item.value.fullAddress}}</span>
                            </li>
                        } 
                        @else if(item.key == 'phones'){
                            @for(nested of item.value | keyvalue:null ; track nested.key){
                                @if(nested.key=='landline1'|| nested.key=='landline2'){
                                    <li class="company-info__item">
                                        <fa-icon [icon]="faPhone"></fa-icon>
                                        <span class="company-info__value">{{ nested.value }}</span>
                                    </li>
                                } @else if(nested.key=='mobile'){
                                    <li class="company-info__item">
                                        <fa-icon [icon]="faWhatsapp"></fa-icon>
                                        <a href="https://wa.me/393348619077" target="_whatsapp">
                                            <span class="company-info__value">{{ nested.value }}</span>
                                        </a>
                                    </li>
                                }
                            }
                        }
                    } @else{
                        @if(item.key=='email'){
                            <li class="company-info__item">
                                <fa-icon [icon]="faEnvelope"></fa-icon>
                                <a href="mailto:{{ company_email }}" class="company-info__value">{{ company_email }}</a>
                            </li>
                        } @else{
                            <li class="company-info__item">
                                @if(item.key=='companyName'){
                                    <h6 class="company-info__value">{{ item.value }}</h6>
                                }
                                @else{
                                    <span class="company-info__value">{{ item.value }}</span>
                                }
                            </li>
                        }
                    }
                }
            </ul>
            <div class="social-icons-wrapper">
                <a href="https://wa.me/393348619077" target="_whatsapp">
                    <div id="icon-wapp" class="social-icon-container">
                        <fa-icon [icon]="faWhatsapp"></fa-icon>
                    </div>
                </a>
                <a href="https://www.instagram.com/emporio.elettrico">
                    <div id="icon-ig" class="social-icon-container">
                        <fa-icon [icon]="faInstagram"></fa-icon>
                    </div>
                </a>
                <a href="https://www.facebook.com/Emporio.Elettrico">
                    <div id="icon-fb" class="social-icon-container">
                        <fa-icon [icon]="faFacebookF"></fa-icon>
                    </div>
                </a>
            </div>
        </div>

        <div class="col-12 col-md-4 col-xl-3 footer-categories">
            <h3 class="footer-categories__title">
                {{ "footer.categorie" | T }}
            </h3>
            <ul class="footer-categories__list">
                @for(category of allCategories; track category.idcategoria){
                <li class="footer-categories__item">
                    <a
                        routerLink="c/c/{{ category.seo_url }}/{{
                            category.idcategoria
                        }}"
                        class="footer-categories__link"
                        [attr.data-category-id]="category.idcategoria"
                    >
                        {{ category.descrizione }}
                    </a>
                </li>
                }
            </ul>
        </div>

        <!-------------------------------------------------- STATIC MENU ------------------------------------------------>
        <div class="col-12 col-md-4 col-xl-2 footer-links-pages">
            <h3 class="footer-links__title">{{ "footer.linkutili" | T }}</h3>
            <ul class="footer-links__list">
                @if(flagBlog){
                    <li class="footer-links__item">
                        <a routerLink="/blog" class="">Blog</a>
                    </li>
                }
                <li class="footer-links__item">
                    <a class="" routerLink="/{{ 'ROUTE.chi-siamo' | T }}">
                        {{ "sidebar.chisiamo" | T }}
                    </a>
                </li>
                <li class="footer-links__item">
                    <a class="" routerLink="/{{ 'ROUTE.dove-siamo' | T }}">
                        {{ "sidebar.dovesiamo" | T }}
                    </a>
                </li>
                <li class="footer-links__item">
                    <a
                        class=""
                        routerLink="/{{ 'ROUTE.spedizioni-e-pagamenti' | T }}"
                    >
                        {{ "sidebar.spedizionepagamenti" | T }}
                    </a>
                </li>
                <li class="footer-links__item">
                    <a class="" routerLink="/{{ 'ROUTE.dati-azienda' | T }}">
                        {{ "sidebar.datiazienda" | T }}
                    </a>
                </li>
                <li class="footer-links__item">
                    <span>
                        <fa-icon class="fa-nostri-store" [icon]="faNostriStore"></fa-icon>
                        <a class="" routerLink="/{{ 'ROUTE.negozi' | T }}">
                            {{ "headertop.ourstore" | T }}
                        </a>
                    </span>
                </li>
                <li class="footer-links__item">
                    <a class="" routerLink="/privacy"> Privacy </a>
                </li>
                
            </ul>
        </div>

        <div class="col-12 col-xl-4 domain-switcher__wrapper">
            <app-domain-switcher></app-domain-switcher>
            <app-payment-method></app-payment-method>
            <app-couriers-logos></app-couriers-logos>
        </div>
 
    </div>
    
    <!-- Footer Bottom -->
    <section class="row footer-bottom emp-section-wrapper-local" aria-label="Informazioni aziendali e riconoscimenti">
        <!-- Prima colonna: Informazioni aziendali -->
        <div class="col-12 col-md-4 footer-left">
            <a class="logo" href="/home" aria-label="Torna alla homepage di Emporio Elettrico">
                <img src="/images/loghi/logo-small.webp" loading="lazy" alt="Logo Emporio Elettrico" class="logo-img">
            </a>
            <div class="footer-text-content">
                <p class="footer-copyright">
                    <small>Copyright © 2015-2025. All Rights Reserved</small>
                </p>
                <p style="font-size: 0.875rem;">
                    <strong>Emporio Elettrico SRL </strong>
                    <abbr title="Partita IVA">P.IVA:</abbr> IT11332290011
                </p>

                <div class="pt-2">
                    <!-- iubenda: privacy e cookie -->
                    <app-iubenda-link tipo="privacy"/>
                    <app-iubenda-link tipo="cookie"/>
                </div>
            </div>

        </div>
        
        <!-- Seconda colonna: Riconoscimenti -->
        <aside class="col-12 col-md-4 riconoscimenti-wrapper d-flex align-items-center justify-content-md-center" aria-label="Riconoscimenti aziendali">
            <img src="/images/loghi/campioni_della_crescita_2024.webp" loading="lazy"
                 alt="Badge Campioni della crescita 2024" class="logo-campioni-img">
        </aside>
        
        <!-- Terza colonna: Certificazioni esterne -->
        <aside class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-end footer-right-col" aria-label="Certificazioni esterne">
            <a href="https://www.aicel.org/categorie/cerca/?q=2952" aria-label="Visita il profilo AICEL di Emporio Elettrico">
                <img src="{{acquisto_intelligente.img}}" loading="lazy"
                     alt="Certificazione AICEL - Acquisto Intelligente" class="additional-image img-fluid" />
            </a>
        </aside>
    </section>

     
</footer>
